import script from "./UlcerIndex.vue?vue&type=script&lang=js"
export * from "./UlcerIndex.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__